import {Component, OnInit} from '@angular/core';
import {SuppliersService} from '../../../../../services/suppliers.service';
import {Observable} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {CreateBlankStatusComponent} from '../create-blank-status/create-blank-status.component';
import {
  UpdateMeasureDialogComponent,
  UpdateMeasureDialogData
} from "../update-measure-dialog/update-measure-dialog.component";
import {ConfirmDialogComponent, ConfirmDialogModel} from "../../../../dialogs/confirm-dialog.component";
import {BlankModel} from "../../../../../services/models/blank-model";
import {SelectionModel} from "@angular/cdk/collections";
import {MatTableDataSource} from "@angular/material/table";
import {BlankStatusModel} from "../../../../../services/models/blank-status-model";
import {ProleisObject} from "@proleis/proleis-rest-client";

const DELIVERED = '8f999f30-2925-11b2-8055-278188925e2c';
const IN_PROGRESS = 'b51981c0-27fa-11b2-800a-b390cd5bbe84';
const REJECTED = 'cc2dd67a-2ced-11b2-80f9-5f5553b55ab9';
const CLOSED = 'fa214324-2918-11b2-801b-13b25b0f8747';
const ORDERED = '2d8b9d48-2925-11b2-8032-e557b030d58d';


@Component({
  selector: 'app-blanks-overview',
  templateUrl: './blanks-overview.component.html',
  styleUrls: ['./blanks-overview.component.scss'],
})
export class BlanksOverviewComponent implements OnInit {
  pos$: Observable<ProleisObject | null> | undefined;
  blanks$: Observable<BlankModel[]> | undefined;
  status$: Observable<BlankStatusModel[]> | undefined;
  dataSource: MatTableDataSource<BlankModel> = new MatTableDataSource<BlankModel>();
  dataSourceMeasures: MatTableDataSource<BlankMeasureViewModel> = new MatTableDataSource<BlankMeasureViewModel>();

  displayedColumnsBlanks: string[] = [
    'BLANK',
    'BLANK_MEASURE_TYPE_TEXT',
    'BLANK_LENGTH',
    'BLANK_WIDTH',
    'BLANK_DEMAND_COUNT',
    'BLANK_DEMAND',
    'STATUS',
    'DELIVERY_DEADLINE',
    'DELIVERY_DATE',
    'ACTIONS'
  ];

  displayedColumnsMeasures: string[] = [
    'BLANK',
    'STATUS',
    'LENGTH',
    'WIDTH',
    'QUANTITY',
    'ACTIONS'
  ]

  displayedColumnsStatus: string[] = [
    'DATE_CREATION',
    'STATUS_NAME',
    'ADDITIONAL_DEMAND',
    'DAMAGE_PRE_MANUFACTURING',
    'DAMAGE_MANUFACTURING',
    'INFO',
    'BLANK_DEMAND_NAME',
    'REMARK',
    'ACTIONS',
  ];


  selection = new SelectionModel<BlankModel>(false, []);

  constructor(
    private supplierService: SuppliersService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
  ) {
  }

  ngOnInit() {
    this.loadPosition();
    this.blanks$ = this.loadBlanks();
    this.status$ = this.loadStatus();

    this.updateDataSources();
  }

  private updateDataSources() {
    this.blanks$?.subscribe(blanks => {
      this.dataSource.data = blanks;
      this.dataSourceMeasures.data = this.createTableData(blanks);
    })
  }

  private createTableData(blanks: BlankModel[]) {
    const data: BlankMeasureViewModel[] = [];
    blanks.forEach(blank => {
      if (blank.measures && blank.measures.length > 0) {
        blank.measures.forEach(measure => {
          data.push({
            blankMaterialText: blank.blankMaterialText,
            blankId: blank.blankId,
            blankMeasureRequestPermitted: blank.blankMeasureRequestPermitted,
            blankMeasureChangePermitted: blank.blankMeasureChangePermitted,
            measure: {
              measureTypeText: measure.measureTypeText,
              measureTypeGuid: measure.measureTypeGuid,
              measureLength: measure.measureLength,
              measureWidth: measure.measureWidth,
              measureQuantity: measure.measureQuantity
            }
          })
        })
      } else {
        data.push({
          blankMaterialText: blank.blankMaterialText,
          blankId: blank.blankId,
          blankMeasureRequestPermitted: blank.blankMeasureRequestPermitted,
          blankMeasureChangePermitted: blank.blankMeasureChangePermitted,
          measure: {
            measureTypeText: 'n.a.',
            measureTypeGuid: '',
            measureLength: 'n.a.',
            measureWidth: 'n.a.',
            measureQuantity: 'n.a.'
          }
        })
      }
    })

    console.log('measureView:', data);

    return data;
  }

  removeButtonsAndText(index: number): boolean {
    if (index < 1) {
      return true;
    }

    const current = this.dataSourceMeasures.data[index];
    const previous = this.dataSourceMeasures.data[index - 1];

    return current.blankId !== previous.blankId;
  }

  removeBorders(index: number): boolean {
    if (index < this.dataSourceMeasures.data.length - 1) {
      const current = this.dataSourceMeasures.data[index];
      const next = this.dataSourceMeasures.data[index + 1];

      return current.blankId === next.blankId;
    }
    return false;
  }

  loadPosition() {
    this.pos$ = this.supplierService.getPosition(
      this.route.snapshot.params.id,
      this.route.snapshot.params.posId,
    );
  }

  loadBlanks() {
    return this.supplierService.getBlanks(
      this.route.snapshot.params.id,
      this.route.snapshot.params.posId,
    );
  }

  loadStatus() {
    return this.supplierService.getBlankStatus(
      this.route.snapshot.params.id,
      this.route.snapshot.params.posId,
    );
  }

  getDemandStatusClass(blank: BlankModel) {
    switch (blank.blankDemandStatusGuid) {
      case DELIVERED:
        return 'tag-green';
      case ORDERED:
        return 'tag-yellow';
      default:
        return 'tag-grey';
    }
  }

  getReportStatusClass(blank: BlankStatusModel) {
    switch (blank.statusGuid) {
      case IN_PROGRESS:
        return 'tag-yellow';
      case REJECTED:
        return 'tag-red';
      case CLOSED:
        return 'tag-green';
      default:
        return 'tag-grey';
    }
  }

  deleteStatus(status: BlankStatusModel) {
    this.supplierService
      .deleteBlankStatus(this.route.snapshot.params.posId, status.blankStatusId)
      .subscribe((result) => {
        this.status$ = this.loadStatus();
      });
  }

  createStatus(blank: BlankModel) {
    this.dialog
      .open(CreateBlankStatusComponent)
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.supplierService
            .createBlankStatus(
              this.route.snapshot.params.posId,
              blank.blankId,
              result.additionalDemand,
              result.damagePreManufacturing,
              result.damageManufacturing,
              result.info,
            )
            .subscribe(result => {
              this.status$ = this.loadStatus();
            });
        }
      });
  }

  updateOrRequestMeasure(blank: BlankModel, measureType: 'PLA_MA_AN' | 'PLA_MA_AB') {
    const dialogData: UpdateMeasureDialogData = {
      measureType
    }
    this.dialog.open(UpdateMeasureDialogComponent, {
      data: dialogData
    }).afterClosed().subscribe((result) => {
      if (result) {
        const confirmDialogData: ConfirmDialogModel = {
          title: 'Bestätigen',
          message: `Möchten Sie die nachfolgenden Maße wirklich speichern? Länge: ${result.length}mm, Breite: ${result.width}mm, Anzahl: ${result.quantity}`
        }
        this.dialog.open(ConfirmDialogComponent, {data: confirmDialogData}).afterClosed().subscribe(confirm => {
          if (confirm) {
            const payload = {...result, measureType}
            this.supplierService.updateMeasures(
              this.route.snapshot.params.id,
              this.route.snapshot.params.posId,
              blank.blankId,
              payload
            ).subscribe(result => {
              this.blanks$ = this.loadBlanks();
              this.updateDataSources();
            });
          }
        })
      }
    })
  }

}

export interface BlankMeasureViewModel {
  blankMaterialText: string;
  blankId: string;
  blankMeasureRequestPermitted: boolean;
  blankMeasureChangePermitted: boolean;
  measure: {
    measureTypeText: string;
    measureTypeGuid: string;
    measureLength: number | string;
    measureWidth: number | string;
    measureQuantity: number | string;
  }
}
